module.exports = (__webpack_require__(4))(782);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-redux/es/index.js from dll-reference vendorProd_library
// module id = 1067
// module chunks = 42